<ui-card [bordered]="true" [shadow]="false" [padding]="'sm'">

  @if (isLoading) {
    <!-- Loading skeleton (single row) -->
    <div class="flex items-center gap-3 animate-pulse">
      <div class="h-6 w-12 bg-base-300 rounded"></div>
      <div class="h-1.5 flex-1 bg-base-300 rounded-full"></div>
      <div class="h-5 w-20 bg-base-300 rounded-full"></div>
    </div>

  } @else if (isEditMode) {
    <!-- Edit / manage target (single row) -->
    <div class="flex items-center gap-2 flex-wrap">
      <span class="text-[0.62rem] font-bold uppercase tracking-wide text-base-content/40 shrink-0">Set target</span>

      <div class="join shrink-0">
        <button type="button" class="btn btn-sm join-item" (click)="stepDown()" aria-label="Decrease target">
          <fa-icon [icon]="faMinus"></fa-icon>
        </button>
        <input
          type="number"
          min="0"
          class="input input-bordered input-sm w-14 text-center join-item font-semibold"
          [(ngModel)]="desiredUpdate"
        />
        <button type="button" class="btn btn-sm join-item" (click)="stepUp()" aria-label="Increase target">
          <fa-icon [icon]="faPlus"></fa-icon>
        </button>
      </div>

      <ui-button variant="primary" size="sm" (clicked)="saveDesiredStock()" [disabled]="!desiredUpdate">
        <fa-icon [icon]="faSave" class="mr-1"></fa-icon> Save
      </ui-button>
      <ui-button variant="ghost" size="sm" tone="transparent" (clicked)="cancelEdit()">Cancel</ui-button>

      @if (desiredStockItemSet && hasTarget) {
        <ui-button variant="danger" tone="link" size="sm" (clicked)="clearDesiredStock()" className="ml-auto">
          Remove
        </ui-button>
      }
    </div>

  } @else if (!hasTarget) {
    <!-- Empty: no target set (single row) -->
    <div class="flex items-center justify-between gap-3">
      <span class="text-sm text-base-content/60 truncate">
        <span class="font-semibold text-base-content">No target set</span>
        <span class="hidden sm:inline">— track when this runs low</span>
      </span>
      <ui-button variant="primary" size="sm" className="shrink-0" (clicked)="enableEditMode()" aria-label="Set target">
        <fa-icon [icon]="faPlus" class="sm:mr-1"></fa-icon>
        <span class="hidden sm:inline">Set target</span>
      </ui-button>
    </div>

  } @else {
    <!-- Display (single row) -->
    <div class="flex items-center gap-3 flex-wrap">
      <div class="shrink-0">
        <div class="text-[0.62rem] font-bold uppercase tracking-wide text-base-content/40 leading-none">Target</div>
        <div class="flex items-baseline gap-1 mt-0.5">
          <span class="text-xl font-bold tabular-nums leading-none">{{ have }}</span>
          <span class="text-sm text-base-content/60 tabular-nums">/ {{ target }}</span>
        </div>
      </div>

      <!-- Meter -->
      <div class="flex-1 min-w-[4rem] h-1.5 rounded-full bg-base-300 overflow-hidden">
        <div
          class="h-full rounded-full transition-all duration-300"
          [ngClass]="{
            'bg-success': statusKey === 'ok',
            'bg-warning': statusKey === 'low',
            'bg-error': statusKey === 'out'
          }"
          [style.width.%]="fillPercent"></div>
      </div>

      @if (showStatusLabel) {
        <span
          class="inline-flex items-center gap-1.5 text-xs font-semibold px-2 py-0.5 rounded-full shrink-0"
          [ngClass]="{
            'bg-success/15 text-success': statusKey === 'ok',
            'bg-warning/15 text-warning': statusKey === 'low',
            'bg-error/15 text-error': statusKey === 'out'
          }">
          <span
            class="w-1.5 h-1.5 rounded-full"
            [ngClass]="{
              'bg-success': statusKey === 'ok',
              'bg-warning': statusKey === 'low',
              'bg-error': statusKey === 'out'
            }"></span>
          @switch (statusKey) {
            @case ('ok') { In stock }
            @case ('low') { Low · {{ missing }} short }
            @case ('out') { Out · {{ missing }} short }
          }
        </span>
      }

      @if (statusKey !== 'ok' && canAddToList) {
        <ui-button variant="secondary" tone="link" size="sm" className="shrink-0" (clicked)="requestAddToList()">
          <fa-icon [icon]="faCart" class="mr-1"></fa-icon> Add
        </ui-button>
      }

      <ui-button variant="ghost" size="sm" className="shrink-0" (clicked)="enableEditMode()" aria-label="Edit target">
        <fa-icon [icon]="faEdit"></fa-icon>
      </ui-button>
    </div>
  }

</ui-card>
